import * as adminFunctions from './admin.js'
import * as userFunctions from './user.js'
import * as contactFunctions from './contact.js'
import * as goalFunctions from './goal.js'
import * as taskFunctions from './task.js'
import * as commitmentFunctions from './commitment.js'
import * as activityFunctions from './activity.js'
import * as challengeFunctions from './challenge.js'
import * as miscFunctions from './misc.js'
import * as sequenceFunctions from './sequence.js'
import * as invitationFunctions from './invitation.js'
import * as timeslotFunctions from './timeslot.js'
import * as authFunctions from './auth.js'

let apiFunctionList = {}

if ( process.env.NODE_ENV === "CLI" ) {
  Object.assign( apiFunctionList, adminFunctions );
  // No HMR...
}

Object.assign( apiFunctionList, userFunctions );
Object.assign( apiFunctionList, contactFunctions );
Object.assign( apiFunctionList, goalFunctions );
Object.assign( apiFunctionList, taskFunctions );
Object.assign( apiFunctionList, commitmentFunctions );
Object.assign( apiFunctionList, activityFunctions );
Object.assign( apiFunctionList, challengeFunctions );
Object.assign( apiFunctionList, miscFunctions );
Object.assign( apiFunctionList, sequenceFunctions );
Object.assign( apiFunctionList, invitationFunctions );
Object.assign( apiFunctionList, timeslotFunctions );
Object.assign( apiFunctionList, authFunctions );

// TODO: Provide automatic help for API functions

if (module.hot) {
  module.hot.accept([
    './user',
    './contact',
    './goal',
    './commitment',
    './task',
    './activity',
    './challenge',
    './misc',
    './sequence',
    './invitation',
    './timeslot',
    './auth',
  ], (filename) => {

    // Parse "./src/api/<moduleName>.js"
    let moduleName = filename[0].split('/').reverse()[0];
    console.log("[HMR*] update api %c<" + moduleName + ">", 'color: #42b983');

    // Path must be hardcoded!
    let updatedModule;
    switch (moduleName) {
      case 'user.js':        updatedModule = require('./user');       break;
      case 'contact.js':     updatedModule = require('./contact');    break;
      case 'goal.js':        updatedModule = require('./goal');       break;
      case 'commitment.js':  updatedModule = require('./commitment'); break;
      case 'task.js':        updatedModule = require('./task');       break;
      case 'activity.js':    updatedModule = require('./activity');   break;
      case 'challenge.js':   updatedModule = require('./challenge');  break;
      case 'misc.js':        updatedModule = require('./misc');       break;
      case 'sequence.js':    updatedModule = require('./sequence');   break;
      case 'invitation.js':  updatedModule = require('./invitation'); break;
      case 'timeslot.js':    updatedModule = require('./timeslot');   break;
      case 'auth.js':        updatedModule = require('./auth');       break;
    }

    for ( let actionName in updatedModule ) {
      apiFunctionList[ actionName ] = updatedModule[ actionName ];
    }
  })
}

export default apiFunctionList;
